module.exports = __webpack_public_path__ + "static/story2-10d878e6bcd67941b4df05420780ecfe.png";